class News {
    constructor(element, options = {}){
        this.options = Object.assign(
            {},
            {    
                config: ""
            }, 
            options
        );    

         
        this.news = element; 
 
        this.news.querySelector("#news-subscribe").addEventListener("click", () => {
            this.news.querySelector("#news-subscribe").classList.add("loading");
            let email =  document.querySelector("#email-news").value;
            this.subBrevo(email, "section-news"); 
        });  

    }   

    async subBrevo(email, source){   
        const call = await fetch(`https://kmv0qf41j4.execute-api.eu-west-3.amazonaws.com/Prod/brevo/subscribe/${email}/${source}`);  
        const rep = await call.json();    
        this.news.querySelector("#news-subscribe").classList.remove("loading");
        this.news.querySelector(".form .content-field").classList.add("hide");
        if(rep.success && !rep.data){
            this.news.querySelector(".form .success").classList.add("ok"); 
        }else if (!rep.success && rep.error == "already_exists"){
            this.news.querySelector(".form .success").classList.add("ok");
            this.news.querySelector(".form .success").textContent = "Vous faites déjà parti de nos abonné(e)s !";
        }else{
            this.news.querySelector(".form .success").classList.add("ok");
            this.news.querySelector(".form .success").textContent = "Désolé, une erreur s'est produite. Veuillez réessayer plus tard.";
        } 
 
    } 

     
} 

window.dispatchEvent(new CustomEvent("news-ready"));